import {
  FETCH_RAIDERS,
} from '../mutation-types'

const initialState = {
  raiders: {
    category: {},
    abstr: '',
  },
}

const mutations = {
  [FETCH_RAIDERS](state, data) {
    state.raiders = data
  },
}

export default {
  state: initialState,
  mutations,
}




// WEBPACK FOOTER //
// ./client/vuex/modules/raiders.js